import React from "react";
import { AthleteFooter } from "./AthleteFooter";
import { AthleteUserHeader } from "./AthleteUserHeader";

const AthleteLayout = ({ children }) => {
  return (
    <div className="h-dvh flex flex-col">
      {/* <div className="p-5 overflow-hidden"> */}
      {/* <div className="p-5 h-dvh overflow-hidden"> */}
      <AthleteUserHeader />
      <main className="overflow-y-hidden bg-black footer-calc">
        {/* <main className="overflow-y-auto footer-calc"> */}
        {children}
      </main>
      <AthleteFooter />
    </div>
  );
};

export default AthleteLayout;
